import type { AppDispatch } from "_shared/_stores/store-types";
import Guid from "_shared/guids/guid";
import type { NavigateFunction } from "react-router";
import type Session from "users/__session/session";
import ProposalBuilder from "work/proposals/__builder/proposal-builder";
import {
  replaceOriginalProposalBuilder,
  replaceUpdatedProposalBuilder,
} from "work/proposals/_store/proposals-redux-slice";
import { PageTab } from "work/proposals/_views/drafts/draft-proposal-page-tabs";

/**
 * Opens the create page on a new draft that something has already filled in: a template, a chosen
 * team leader, or a previous proposal.
 *
 * The baseline is an empty new draft, never the filled one. The page offers Save, and warns before
 * the user leaves, only while the draft differs from its baseline. With the filled draft as its own
 * baseline, everything it held read as already saved: Save stayed disabled until the user changed
 * something by hand, and leaving lost the draft without a word (#1569).
 */
export function openUnsavedDraft(args: {
  builder: ProposalBuilder;
  session: Session;
  dispatch: AppDispatch;
  navigate: NavigateFunction;
  pageTab: PageTab;
}) {
  const { builder, session, dispatch, navigate, pageTab } = args;
  dispatch(replaceOriginalProposalBuilder({ proposalId: Guid.EMPTY, builder: new ProposalBuilder({ session }) }));
  dispatch(replaceUpdatedProposalBuilder({ proposalId: Guid.EMPTY, builder }));
  navigate(`/proposals/drafts/create/${pageTab}`);
}
